export const UPDATE_APPROVAL_TOUR_LIST_START = "UPDATE_APPROVAL_TOUR_LIST_START";
export const UPDATE_APPROVAL_TOUR_LIST_SUCCESS = "UPDATE_APPROVAL_TOUR_LIST_SUCCESS";
export const UPDATE_APPROVAL_TOUR_LIST_ERROR = "UPDATE_APPROVAL_TOUR_LIST_ERROR";
export const UPDATE_APPROVAL_TOUR_LIST_CLEAR = "UPDATE_APPROVAL_TOUR_LIST_CLEAR";
export const UPDATE_APPROVAL_TOUR_INFO_START = "UPDATE_APPROVAL_TOUR_INFO_START";
export const UPDATE_APPROVAL_TOUR_INFO_SUCCESS = "UPDATE_APPROVAL_TOUR_INFO_SUCCESS";
export const UPDATE_APPROVAL_TOUR_INFO_ERROR = "UPDATE_APPROVAL_TOUR_INFO_ERROR";
export const UPDATE_APPROVAL_TOUR_SEND_START = "UPDATE_APPROVAL_TOUR_SEND_START";
export const UPDATE_APPROVAL_TOUR_SEND_SUCCESS = "UPDATE_APPROVAL_TOUR_SEND_SUCCESS";
export const UPDATE_APPROVAL_TOUR_SEND_ERROR = "UPDATE_APPROVAL_TOUR_SEND_ERROR";